(function () {
  'use strict';

  angular
    .module('itecAdministracio.usuaris')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.when('/usuaris', '/usuaris/');

    $stateProvider
      .state('usuaris', {
        url: '/usuaris',
        views: {
          'wrapper': {
            templateUrl: 'usuaris/usuaris.tpl.html',
            controller: function(AppHeaderSubmenuFactory, $stateParams, $scope, $rootScope) {
              var vm = this;

              $scope.$on('changeSides', function (event, data) {
                AppHeaderSubmenuFactory.setStateParams($stateParams, data, false);
                AppHeaderSubmenuFactory.setWrapperAttributesFromChild(vm, data);
              });
            },
            controllerAs: 'ctrl'
          }
        },
        resolve: {
          permisosLoad: function(PermisosFactory, LocaleService, $rootScope, DataFactory, ApiLayoutConstant) {
            if (angular.isUndefined($rootScope.permisos) && $rootScope.permisos == null ) {
              /* Hay casos en que se ejecuta antes este "resolve" que el controlador de la "app"
                 ("/app-controller.js") y, por tanto, los permisos no llegan definidos aquí. */

              DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO,
                  'authsecurity','');
              PermisosFactory.setApiParameters(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'permisos',
                  'notfound');

              var promise= PermisosFactory.load().then(function (response) {
                $rootScope.permisos = response.data.permisos;
                $rootScope.usuari = response.data.usuari;
                LocaleService.setLocaleByIdioma($rootScope.usuari.idioma);
              });
              return promise;
            }
          }
        },
        breadcrumb: "DEFAULT_USUARIS"
     });
  }
}());
